ace.define('ace/snippets/hcpgrammar', [ 'require', 'exports', 'module' ], function(require, exports, module) {
	'use strict';
	exports.snippetText =
		'#Prototype\n\
# if \n\
snippet if \n\
	if(${1:<condition>}) then \n\
		${2:<expression>}\n\
	endif\n\
		${0}\
	\n\
# if then else endif \n\
snippet ifelse \n\
	if(${1:<condition>}) then \n\
		${2:<expression>}\n\
	else \n\
		${3:<expression>}\n\
	endif\n\
		${0}\n\
# Arithmetic Functions\n\
\n\
# Abs \n\
snippet Abs \n\
	Abs(${1:<input>})\n\
# Ceil \n\
snippet Ceil \n\
	Ceil(${1:<input>})\n\
# Exp \n\
snippet Exp \n\
	Exp(${1:<input>})\n\
# Floor \n\
snippet Floor \n\
	Floor(${1:<input>})\n\
# Log \n\
snippet Log \n\
	Log(${1:<input>})\n\
# ln \n\
snippet ln \n\
	ln(${1:<input>})\n\
# Pow \n\
snippet Pow \n\
	Pow(${1:<input>})\n\
# Round \n\
snippet Round \n\
	Round(${1:<input>})\n\
# Sqrt \n\
snippet Sqrt \n\
	Sqrt(${1:<input>})\n\
#Trigonometric Functions \n\
# cos \n\
snippet Cos \n\
	Cos(${1:<input>})\n\
# sin \n\
snippet Sin \n\
	Sin(${1:<input>})\n\
# tan \n\
snippet Tan \n\
	Tan(${1:<input>})\n\
# cosh \n\
snippet Cosh \n\
	Cosh(${1:<input>})\n\
# sinh \n\
snippet Sinh \n\
	Sinh(${1:<input>})\n\
# tanh \n\
snippet tanh \n\
	Tanh(${1:<input>})\n\
# acos \n\
snippet Acos \n\
	Acos(${1:<input>})\n\
# asin \n\
snippet Asin \n\
	Asin(${1:<input>})\n\
# atan \n\
snippet Atan \n\
	Atan(${1:<input>})\n\
# Aggregate Functions \n\
# Max \n\
snippet Max \n\
	Max(${1:<input1>}, ${2:<input2>})\n\
# Min \n\
snippet Min \n\
	Min(${1:<input1>}, ${2:<input2>})\n\
# Sum \n\
snippet Sum \n\
	Sum(${1:<input1>}, ${2:<input2>})\n\
#standard deviation \n\
snippet Std \n\
	Std(${1:<input1>}, ${2:<input2>})\n\
#Variance \n\
snippet Var \n\
#Average \n\
snippet Average \n\
	Average(${1:<input1>}, ${2:<input2>})\n\
#Norm \n\
snippet Norm \n\
	Norm(${1:<input1>}, ${2:<input2>})\n\
#Median \n\
snippet Median \n\
	Median(${1:<input1>}, ${2:<input2>})\n\
#Count \n\
snippet Count \n\
	Count(${1:<input1>}, ${2:<input2>})\n\
# TWA \n\
snippet TWA \n\
	TWA(${1:<input>})\n\
#Interplote \n\
snippet Interpolate \n\
	Interpolate(${1:<xvalue[]>}, ${2:<yvalue[]>}, ${3:<x>}, ${4:<type>})\n\
#Bit Manipulation Functions \n\
snippet Bitset \n\
	Bitset(${1:<Number>}, ${2:<Position>}, ${3:<Value>})\n\
snippet Bitget \n\
	Bitget(${1:<Number>}, ${2:<Position>})\n\
#Special Functions\n\
snippet Range \n\
	Range(${1:<TagAttributes>}, ${2:<LTval>}, ${3:<GTval>}, ${4:<OprType>})\n\
snippet Group \n\
	Group(${1:<MinDifference>}, ${2:<MinDiffType>}, ${3:<TagAttributes[]>})\n\
snippet ROC \n\
	ROC(${1:<Level>})\n\
snippet Ema \n\
	Ema(${1:<input>}, ${2:<period>})\n\
#Data PreProcessing Functions\n\
snippet IsNan \n\
	IsNan(${1:<input>})\n\
snippet IsNull \n\
	IsNull(${1:<input>})\n\
snippet IsBad \n\
	IsBad(${1:<input>})\n\
snippet ReplaceBadValue \n\
	Replacebadvalue(${1:<actualvalue>}, ${2:<replacevalue>})\n\
snippet OverrideValue \n\
	Overridevalue(${1:<actualvalue>}, ${2:<overridevalue>}, ${3:<conditionvalue>} > ${4:<condition>})\n\
snippet LogMsg \n\
	LogMsg(${<message>})\n\
snippet ThrowError \n\
	Throwerror(${1:<message>})\n\
snippet Quality \n\
	Quality${0}\n\
snippet Filter \n\
	Filter(${1:<inputarray[]>}, ${2:<conditionvaluearray[]>} == ${3:<condition>})\n\
#DateTime Functions \n\
snippet DTValue\n\
	DTValue(${1:<input>})${0}\n\
snippet Time\n\
	Time${0}\n\
snippet DTAdd \n\
	DTAdd(${1:<input1>},${2:<input2>})${0}\n\
snippet Age \n\
	Age(${1:<input>})${0}\n\
#String Functions\n\
snippet SubString \n\
	SubString(${1:<input>}, ${2:<startindex>}, ${3:<length>})${0}\n\
snippet Replace \n\
	Replace(${1:<input>}, ${2:<oldstring>}, ${3:<newstring>})${0}\n\
snippet Trim \n\
	Trim${0}\n\
snippet Length \n\
	Length${0}\n\
snippet ToLower \n\
	ToLower${0}\n\
snippet ToUpper \n\
	ToUpper${0}\n\
snippet ToNumber \n\
	ToNumber${0}\n\
snippet ToString \n\
	ToString${0}\n\
snippet Contains \n\
	Contains(${1:<input>}, ${2:<searchstring>})${0}\n\
';

	exports.scope = 'hcpgrammar';
});
